module.exports = __webpack_public_path__ + "img/games.a86556a0.svg";